export default __webpack_public_path__ + "static/media/about.fad42c52.webp";